export const SECUREMAC_HERO_STRAPLINE =
  "SecureShield by LightningFlow — Know Your Mac's Real Security State";

export const SECUREMAC_CUSTOMER_PROMISE = Object.freeze({
  headline: "See what's actually protecting your Mac.",
  description:
    "SecureShield provides eight automatic checks and four manual guidance items, shows what needs attention, and opens the relevant System Settings pane.",
});

/** The twelve checks available in the Mac App Store edition. */
export const SECUREMAC_CHECK_CATEGORIES = Object.freeze([
  Object.freeze(["01", "Essential Protection", "Firewall, Stealth Mode and Block Incoming Connections — protections every Mac owner can review."]),
  Object.freeze(["02", "macOS Integrity", "Gatekeeper, System Integrity Protection and Startup Security. SecureShield never offers to turn SIP off."]),
  Object.freeze(["03", "Exposure", "Remote Login, Screen Sharing, File Sharing, Guest Account, Automatic Login and screen-lock timing — only a risk if switched on by accident."]),
]);

/** Pro retains all fourteen checks, including FileVault and security updates. */
export const SECUREMAC_PRO_CHECK_CATEGORIES = Object.freeze([
  Object.freeze(["01", "Essential Protection", "FileVault, Firewall, Stealth Mode and Block Incoming Connections — the baseline almost every Mac should have on."]),
  Object.freeze(["02", "macOS Integrity", "Gatekeeper, System Integrity Protection, Startup Security and Automatic Security Updates. SecureShield Pro never offers to turn SIP off."]),
  SECUREMAC_CHECK_CATEGORIES[2],
]);

export const SECURESHIELD_AUDIT_DISCIPLINE = Object.freeze({
  claim: "Audit. Plan. Change. Verify.",
  title: "Automatic checks and honest manual guidance.",
  method: "How SecureShield works",
  steps: Object.freeze([
    Object.freeze({ label: "Audit", body: "Read eight supported settings from macOS; label four manual guides clearly." }),
    Object.freeze({ label: "Plan", body: "Show exactly what would change before anything happens." }),
    Object.freeze({ label: "Change", body: "Review the relevant System Settings pane and make your own changes." }),
    Object.freeze({ label: "Verify", body: "Re-check automatic settings. Firewall and Startup Security guidance does not claim verified readback." }),
  ]),
  test_note:
    "If a change can't be confirmed against real system state afterward, SecureShield says so honestly instead of claiming success.",
});

export const SECUREMAC_PRIVACY_CONTROLS = Object.freeze({
  eyebrow: "Privacy controls",
  title: "Camera. Microphone. Screen Recording.",
  body:
    "Three quick controls sit right in the SecureShield dashboard. One tap opens the exact Privacy & Security pane in System Settings — you decide which apps keep access.",
  honesty:
    "macOS grants these permissions per app, and only you can change them. SecureShield never flips Camera, Microphone or Screen Recording silently, and never claims Protected or Blocked without a verification it can actually perform.",
  controls: Object.freeze([
    Object.freeze({
      id: "camera",
      label: "Camera",
      symbol: "video",
      body: "Jump straight to Camera privacy settings when you want to review which apps can see you.",
    }),
    Object.freeze({
      id: "microphone",
      label: "Microphone",
      symbol: "mic",
      body: "Open Microphone privacy settings in one tap — no digging through System Settings menus.",
    }),
    Object.freeze({
      id: "screenRecording",
      label: "Screen Recording",
      symbol: "rectangle.on.rectangle",
      body: "Land on Screen Recording privacy settings when you want to tighten who can capture your display.",
    }),
  ]),
});

export const SECUREMAC_AUDIT_DISCIPLINE = Object.freeze({
  claim: "Audit. Plan. Change. Verify.",
  title: "Every fix is checked, not assumed.",
  method: "How SecureShield works",
  steps: Object.freeze([
    Object.freeze({ label: "Audit", body: "Read the real setting from macOS — not a cached guess." }),
    Object.freeze({ label: "Plan", body: "Show exactly what would change before anything happens." }),
    Object.freeze({ label: "Change", body: "Make the change the safe way — guided in System Settings, or in one click with SecureShield Pro." }),
    Object.freeze({ label: "Verify", body: "Read the setting again. Nothing is marked fixed until macOS shows the change." }),
  ]),
  test_note:
    "If a change can't be confirmed against real system state afterward, SecureShield says so honestly instead of claiming success.",
});
